<script setup>
import { configureEcho } from '@laravel/echo-vue'

import { getAccessToken } from '@/helpers/auth-helper'

import { useUserNotifications } from '@/composables/echo/useUserNotifications'
import { useMaintenanceChannel } from '@/composables/echo/useMaintenanceChannel'
import { useHeaderMetrics } from '@/composables/echo/useHeaderMetrics'

configureEcho({
    broadcaster: 'reverb',
    forceTLS: import.meta.env.VITE_NODE_ENV === 'local',
    authEndpoint: `${import.meta.env.VITE_API_URL}/broadcasting/auth`,
    wsPort: import.meta.env.VITE_REVERB_PORT,
    wssPort: import.meta.env.VITE_REVERB_WS_PORT,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    auth: {
        headers: {
            Authorization: `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
        },
    },
    namespace: '',
})

useUserNotifications()
useMaintenanceChannel()
useHeaderMetrics()
</script>
